import React, { PropsWithChildren } from 'react';
import WarningOutlined from '@mui/icons-material/WarningOutlined';
import Box from '@mui/material/Box';
import { SpacingProps } from '@mui/system';
import { i18n_error } from '@yi/i18n/phrases/i18n_error';

import { errorRed } from '~/styles';

import { useLocale } from './LocaleProvider';

export const ErrorMessage: React.FC<
  PropsWithChildren<
    {
      message: string;
      style?: React.CSSProperties;
      className?: string;
    } & SpacingProps
  >
> = ({ message, style, ...props }) => {
  const { locale } = useLocale();
  return (
    <Box
      style={{
        color: errorRed,
        boxShadow: '-1px 6px 34px 0px rgba(0, 0, 0, 0.08)',
        ...style,
      }}
      p={2}
      border={`2px solid ${errorRed}`}
      borderRadius="6px"
      maxWidth={600}
      mx="auto"
      role="alert"
      {...props}
    >
      <Box mb={2} fontWeight={500}>
        <WarningOutlined style={{ marginBottom: -5, marginRight: 8 }} />
        {i18n_error(locale)}
      </Box>
      <Box>{message}</Box>
    </Box>
  );
};
